import React, { useEffect, useState } from 'react';
import '../../styles/Placements.css';

import recruiter1 from '../../images/recruiter-1.jpg';
import recruiter2 from '../../images/recruiter-2.jpg';
import recruiter3 from '../../images/recruiter-3.jpg';
import recruiter4 from '../../images/recruiter-4.jpg';
import recruiter5 from '../../images/recruiter-5.jpg';
import recruiter6 from '../../images/recruiter-6.jpg';
import recruiter7 from '../../images/recruiter-7.jpg';
import recruiter8 from '../../images/recruiter-8.jpg';
import recruiter9 from '../../images/recruiter-9.jpg';
import recruiter10 from '../../images/recruiter-10.jpg';
import recruiter11 from '../../images/recruiter-11.jpg';
import recruiter12 from '../../images/recruiter-12.jpg';
import recruiter13 from '../../images/recruiter-13.jpg';
import recruiter14 from '../../images/recruiter-14.jpg';
import recruiter15 from '../../images/recruiter-15.jpg';
import recruiter16 from '../../images/recruiter-16.jpg';

const Placement = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  const companies = [
    { name: 'Deloitte', logo: recruiter1 },
    { name: 'Bharat Biotech', logo: recruiter2 },
    { name: 'Adobe', logo: recruiter3 },
    { name: 'Flipkart', logo: recruiter4 },
    { name: 'Accenture', logo: recruiter5 },
    { name: 'Cognizant', logo: recruiter6 },
    { name: 'Infosys', logo: recruiter7 },
    { name: 'Samsung', logo: recruiter8 },
    { name: 'Wipro', logo: recruiter9 },
    { name: 'Yardi', logo: recruiter10 },
    { name: 'Ola Electric', logo: recruiter11 },
    { name: 'Capgemini', logo: recruiter12 },
    { name: 'Goldman Sachs', logo: recruiter13 },
    { name: 'Hero', logo: recruiter14 },
    { name: 'Amazon', logo: recruiter15 },
    { name: 'TCS', logo: recruiter16 },
  ];

  return (
    <section className="section-container">
      <section className={`placement-section ${isVisible ? 'fade-in' : ''}`}>
        <h4 className="college-name-placements">SHRI MULIKADEVI MAHAVIDYALAYA, NIGHOJ</h4>
        <h2 className="heading">Placements & Career Opportunities</h2>
        <p className="subheading">
          Explore exceptional placement support and industry tie-ups that guide our students toward successful careers.
        </p>

        <div className="slider-container">
          <div className="logo-slider">
            {[...companies, ...companies].map((company, index) => (
              <div className="logo-slide animate-delay" key={index}>
                <img src={company.logo} alt={company.name} />
                <p>{company.name}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </section>
  );
};

export default Placement;
